/** Environment-specific — do not overwrite when promoting theme to production. */
export const RESTAURANT_ID = '8ecc8e4d-f3bf-4116-9010-3436ec1a5baa';
